import { SearchInfo } from '@insurancemenu/imenu-components-lib/dist/types/SearchBlock';
import { celticsRights, adminRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { searchGroupsByName } from 'api/operations/groupService';
import { makeAutoObservable, runInAction, toJS } from 'mobx';
import { getRootStoreInstance, RootStore } from 'store/rootStore';

export class SearchGroupDelegate {
  private _rootStore: RootStore = getRootStoreInstance();
  private _filteredGroups: SearchInfo[] = [];

  public get filteredGroups(): SearchInfo[] {
    return this._filteredGroups;
  }

  public resetFilteredGroups(): void {
    this._filteredGroups = [];
  }

  public async searchGroups(searchValue: string): Promise<void> {
    const trimmedValue = searchValue.trim();
    if (!trimmedValue) {
      this.resetFilteredGroups();
      return;
    }
    const userRoles = toJS(this._rootStore.userStore.userRoles);
    const res = await searchGroupsByName(trimmedValue, 10, celticsRights(userRoles) || adminRights(userRoles));
    runInAction(() => {
      this._filteredGroups = res
        .map((group) => ({
          ...group,
          disabled: !group.canAccess,
        }))
        // Show disabled groups at the end
        .sort((a, b) => +a.disabled - +b.disabled);
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
